const FADE_MS = 260; // keep in sync with the results wrapper transition in the twig

export default function Indsatser() {
  Alpine.data("indsatser", () => ({
    items: [], // card elements, collected on init

    // --- Input state (what the controls write to) ---
    interventiontype: "",
    municipality: "",
    searchInput: "", // live value of the search field

    // --- Applied state (what actually filters the grid) ---
    activeInterventiontype: "",
    activeMunicipality: "",
    activeSearch: "",

    _busy: false,
    _pending: false,
    _reduceMotion: false,

    init() {
      this.items = Array.from(this.$root.querySelectorAll("[data-indsats]"));
      this._reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;

      // Dropdowns commit immediately; the search field waits for submit.
      this.$watch("interventiontype", () => this.apply());
      this.$watch("municipality", () => this.apply());
    },

    // Search is active once a query has been submitted
    get isSearching() {
      return this.activeSearch !== "";
    },

    // Show the reset button whenever anything is set
    get isActive() {
      return (
        this.activeSearch !== "" ||
        this.interventiontype !== "" ||
        this.municipality !== "" ||
        this.searchInput !== ""
      );
    },

    // Visible-card count for the "no results" message (reactive via active state)
    get resultCount() {
      return this.items.reduce((n, el) => (this.isVisible(el) ? n + 1 : n), 0);
    },

    isVisible(el) {
      // A submitted search overrides the filters
      if (this.activeSearch) {
        return (el.dataset.search || "").includes(this.activeSearch);
      }

      if (this.activeInterventiontype) {
        const tags = (el.dataset.interventiontype || "").split(" ");
        if (!tags.includes(this.activeInterventiontype)) return false;
      }

      if (this.activeMunicipality) {
        const tags = (el.dataset.municipality || "").split(" ");
        if (!tags.includes(this.activeMunicipality)) return false;
      }

      return true;
    },

    // Search only runs on Enter / button click
    submitSearch() {
      if (this.searchInput.trim() !== "") {
        // Reset and override the filters
        this.interventiontype = "";
        this.municipality = "";
      }
      this.apply();
    },

    reset() {
      this.interventiontype = "";
      this.municipality = "";
      this.searchInput = "";
      this.apply();
    },

    // Collapse every state change in this tick into one transition
    apply() {
      cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => this.runTransition());
    },

    // Move input state -> applied state
    commit() {
      this.activeInterventiontype = this.interventiontype;
      this.activeMunicipality = this.municipality;
      this.activeSearch = this.searchInput.trim().toLowerCase();
    },

    // Fade the results container out, swap the filters, fade it back in.
    // The container holds a min-height (100svh in the twig) so it never collapses.
    runTransition() {
      const el = this.$refs.results;

      if (!el || this._reduceMotion) {
        this.commit();
        return;
      }

      if (this._busy) {
        this._pending = true;
        return;
      }
      this._busy = true;

      el.style.opacity = "0";

      setTimeout(() => {
        this.commit();

        requestAnimationFrame(() => {
          el.style.opacity = "1";

          setTimeout(() => {
            this._busy = false;
            if (this._pending) {
              this._pending = false;
              this.runTransition();
            }
          }, FADE_MS);
        });
      }, FADE_MS);
    },
  }));
}
